import { Component, Input } from '@angular/core';
import { CultureInfo } from '@app/core/types/config/config.types';

@Component({
  selector: 'c-language-item',
  templateUrl: './language-item.component.html',
  styleUrls: ['./language-item.component.scss'],
  standalone: false,
})
export class LanguageItemComponent {
  @Input() language: CultureInfo;
  @Input() variant: 'select' | 'button';
  @Input() loading = false;
}
